// import React, { useState, useEffect } from "react";
// import { Box, Button, Typography } from "@mui/material";
// import { DataGrid, GridActionsCellItem, GridRowModes, GridToolbarContainer } from "@mui/x-data-grid";
// import AddIcon from "@mui/icons-material/Add";
// import SaveIcon from "@mui/icons-material/Save";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import axios from "axios";

// const CustomToolbar = ({ setRows }) => {
//   const handleAddSystem = () => {
//     setRows((prevRows) => [
//       ...prevRows,
//       {
//         id: prevRows.length + 1, // Generate a unique ID for the new system
//         systemName: "",
//         systemUrl: "",
//         isNew: true,
//       },
//     ]);
//   };

//   return (
//     <GridToolbarContainer>
//       <Button
//         variant="contained"
//         color="primary"
//         startIcon={<AddIcon />}
//         onClick={handleAddSystem}
//         sx={{ marginLeft: "auto" }}
//       >
//         Add System
//       </Button>
//     </GridToolbarContainer>
//   );
// };

// const SystemManagement = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [rowModesModel, setRowModesModel] = useState({});

//   // Fetch systems from the API
//   const fetchSystems = async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}/systems`);
//       setRows(response.data);
//     } catch (error) {
//       console.error("Failed to fetch systems:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSystems();
//   }, []);

//   // Save Row Updates
//   const processRowUpdate = (newRow) => {
//     const updatedRow = { ...newRow, isNew: false };
//     setRows((prevRows) =>
//       prevRows.map((row) => (row.id === newRow.id ? updatedRow : row))
//     );
//     return updatedRow;
//   };

//   // Edit Row
//   const handleEditClick = (id) => {
//     setRowModesModel((prevModel) => ({
//       ...prevModel,
//       [id]: { mode: GridRowModes.Edit },
//     }));
//   };

//   // Save Row
//   const handleSaveClick = (id) => {
//     setRowModesModel((prevModel) => ({
//       ...prevModel,
//       [id]: { mode: GridRowModes.View },
//     }));
//   };

//   // Cancel Edit
//   const handleCancelClick = (id) => {
//     setRowModesModel((prevModel) => ({
//       ...prevModel,
//       [id]: { mode: GridRowModes.View, ignoreModifications: true },
//     }));
//     const editedRow = rows.find((row) => row.id === id);
//     if (editedRow.isNew) {
//       setRows((prevRows) => prevRows.filter((row) => row.id !== id));
//     }
//   };

//   // Delete Row
//   const handleDeleteClick = (id) => {
//     setRows((prevRows) => prevRows.filter((row) => row.id !== id));
//   };

//   // Columns Configuration
//   const columns = [
//     { field: "id", headerName: "ID", flex: 1 },
//     { field: "systemName", headerName: "System Name", flex: 2, editable: true },
//     { field: "systemUrl", headerName: "System URL", flex: 3, editable: true },
//     {
//       field: "actions",
//       type: "actions",
//       headerName: "Actions",
//       flex: 1.5,
//       getActions: ({ id }) => {
//         const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
//         if (isInEditMode) {
//           return [
//             <GridActionsCellItem
//               icon={<SaveIcon />}
//               label="Save"
//               onClick={() => handleSaveClick(id)}
//               color="primary"
//             />,
//             <GridActionsCellItem
//               icon={<DeleteIcon />}
//               label="Cancel"
//               onClick={() => handleCancelClick(id)}
//               color="inherit"
//             />,
//           ];
//         }

//         return [
//           <GridActionsCellItem
//             icon={<EditIcon />}
//             label="Edit"
//             onClick={() => handleEditClick(id)}
//             color="primary"
//           />,
//           <GridActionsCellItem
//             icon={<DeleteIcon />}
//             label="Delete"
//             onClick={() => handleDeleteClick(id)}
//             color="inherit"
//           />,
//         ];
//       },
//     },
//   ];

//   return (
//     <Box sx={{ p: 3, height: "100%", width: "100%" }}>
//       <Typography variant="h4" gutterBottom>
//         System Management
//       </Typography>
//       <DataGrid
//         rows={rows}
//         columns={columns}
//         autoHeight
//         loading={loading}
//         rowModesModel={rowModesModel}
//         onRowModesModelChange={setRowModesModel}
//         processRowUpdate={processRowUpdate}
//         slots={{
//           toolbar: CustomToolbar,
//         }}
//         slotProps={{
//           toolbar: { setRows },
//         }}
//         experimentalFeatures={{ newEditingApi: true }}
//       />
//     </Box>
//   );
// };

// export default SystemManagement;


import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowModes,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";

const CustomToolbar = ({ setRows }) => {
  const handleAddSystem = () => {
    setRows((prevRows) => [
      ...prevRows,
      {
        id: `temp-${Date.now()}`, // Temporary unique ID
        name: "",
        url: "",
        isNew: true,
      },
    ]);
  };

  return (
    <GridToolbarContainer>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleAddSystem}
        sx={{ marginLeft: "auto" }}
      >
        Add System
      </Button>
    </GridToolbarContainer>
  );
};

const SystemManagement = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rowModesModel, setRowModesModel] = useState({});

  const API_URL = `${process.env.REACT_APP_API_URL}/support-management/client`;

  // Fetch systems from the API
  const fetchSystems = async () => {
    try {
      const response = await axios.get(API_URL);
      setRows(
        response.data.map((system) => ({
          ...system,
          id: system._id, // Map MongoDB `_id` to `id` for MUI compatibility
          isNew: false,
        }))
      );
    } catch (error) {
      console.error("Failed to fetch systems:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSystems();
  }, []);

  // Add new system
  const createSystem = async (data) => {
    try {
      const response = await axios.post(API_URL, data);
      return response.data.client; // Assuming the response contains the created client under `client`
    } catch (error) {
      console.error("Failed to create system:", error);
      throw error;
    }
  };

  // Update system
  const updateSystem = async (id, data) => {
    try {
      await axios.put(`${API_URL}/${id}`, data);
    } catch (error) {
      console.error("Failed to update system:", error);
      throw error;
    }
  };

  // Delete system
  const deleteSystem = async (id) => {
    try {
      await axios.delete(`${API_URL}/${id}`);

      setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    } catch (error) {
      console.error("Failed to delete system:", error);
      throw error;
    }
  };

  // Save Row Updates
  const processRowUpdate = async (newRow) => {
    const { id, name, isNew } = newRow;

    if (isNew) {
      try {
        const createdSystem = await createSystem({ name });
        const updatedRow = {
          ...createdSystem,
          id: createdSystem._id, // Map MongoDB `_id` to `id` for MUI compatibility
          isNew: false,
        };
        setRows((prevRows) =>
          prevRows.map((row) => (row.id === id ? updatedRow : row))
        );
        return updatedRow;
      } catch {
        throw new Error("Failed to save new system");
      }
    } else {
      try {
        await updateSystem(id, { name });
        const updatedRow = { ...newRow, isNew: false };
        setRows((prevRows) =>
          prevRows.map((row) => (row.id === id ? updatedRow : row))
        );
        return updatedRow;
      } catch {
        throw new Error("Failed to update system");
      }
    }
  };

  // Edit Row
  const handleEditClick = (id) => {
    setRowModesModel((prevModel) => ({
      ...prevModel,
      [id]: { mode: GridRowModes.Edit },
    }));
  };

  // Save Row
  const handleSaveClick = (id) => {
    setRowModesModel((prevModel) => ({
      ...prevModel,
      [id]: { mode: GridRowModes.View },
    }));
  };

  // Cancel Edit
  const handleCancelClick = (id) => {
    setRowModesModel((prevModel) => ({
      ...prevModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    }
  };

  // Delete Row
  const handleDeleteClick = async (id) => {
    try {
      await deleteSystem(id);
      setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    } catch {
      console.error("Failed to delete system");
    }
  };

  // Columns Configuration
  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "name", headerName: "System Name", flex: 2, editable: true },
    { field: "url", headerName: "System URL", flex: 3, editable: false },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1.5,
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              onClick={() => handleSaveClick(id)}
              color="primary"
            />,
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Cancel"
              onClick={() => handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            onClick={() => handleEditClick(id)}
            color="primary"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  return (
    <Box sx={{ p: 3, height: "100%", width: "100%" }}>
      <Typography variant="h4" gutterBottom>
        System Management
      </Typography>
      <DataGrid
        rows={rows}
        columns={columns}
        autoHeight
        loading={loading}
        rowModesModel={rowModesModel}
        onRowModesModelChange={setRowModesModel}
        processRowUpdate={processRowUpdate}
        slots={{
          toolbar: CustomToolbar,
        }}
        slotProps={{
          toolbar: { setRows },
        }}
        experimentalFeatures={{ newEditingApi: true }}
      />
    </Box>
  );
};

export default SystemManagement;